import React, { FunctionComponent } from 'react';
import { useI18n } from 'app/components/localization';
import LogoutLink from 'app/components/auth/LogoutLink';
import NavLink from 'app/components/presentation/nav/NavLink';
import NavDropdown from 'app/components/presentation/nav/NavDropdown';
import RestrictContent from 'app/containers/auth/RestrictContent';
import UserSilhouette from 'app/components/svgs/UserSilhouette';
import { EditProfileRoute, StaffProfileRoute } from 'app/constants/Routes';
import { STAFF_MANAGEMENT_PERMISSIONS } from 'app/constants/enums/Ability';
import { useHoverState } from '@engoo/react-hover-state';
import { useCss } from 'app/utils/css';
import { getNavLinkStyles } from 'app/components/presentation/nav/styles';

const AccountDropdown: FunctionComponent = () => {
  const { t } = useI18n();
  const [logoutLinkHovered, logoutLinkHoverRef] = useHoverState();
  const css = useCss();

  return (
    <NavDropdown
      alignRight
      showArrow={false}
      icon={<UserSilhouette size="25px" />}
    >
      <NavLink to={EditProfileRoute.getPathname()}>
        {t('admin.header.edit-profile')}
      </NavLink>

      <RestrictContent allow={STAFF_MANAGEMENT_PERMISSIONS}>{isRestricted => (
        !isRestricted &&
          <NavLink to={StaffProfileRoute.getPathname()}>
            {t('admin.header.edit-staff-profile')}
          </NavLink>
      )}</RestrictContent>

      <LogoutLink
        className={css(
          'logoutLink',
          getNavLinkStyles({ active: false, hovered: logoutLinkHovered, logo: false, selected: false }),
        )}
        getRef={logoutLinkHoverRef}
      >
        {t('admin.header.logout-link')}
      </LogoutLink>
    </NavDropdown>
  );
};

export default AccountDropdown;
